// App.js
import Game from "./components/Game";

export default function App() {
return <Game />
}
